module.exports = "../../app/cells/components/modals/questions_intervention_modal_cell.rb";